'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\n  '], ['\n    color: ', ';\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding-left: 0;\n  '], ['\n    padding-left: 0;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    > div {\n      grid-template-columns: 1fr;\n    }\n  '], ['\n    > div {\n      grid-template-columns: 1fr;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UICardSection = require('UIComponents/card/UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _UICardGrid = require('UIComponents/card/UICardGrid');

var _UICardGrid2 = _interopRequireDefault(_UICardGrid);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _BizObjectivesMap = require('self-service-api/constants/BizObjectivesMap');

var _BizObjectivesMap2 = _interopRequireDefault(_BizObjectivesMap);

var _getFeatureDescriptionKey = require('self-service-api/core/utilities/getFeatureDescriptionKey');

var _getFeatureDescriptionKey2 = _interopRequireDefault(_getFeatureDescriptionKey);

var _HighlightedMerchBizObjectives = require('self-service-api/constants/HighlightedMerchBizObjectives');

var _HighlightedMerchBizObjectives2 = _interopRequireDefault(_HighlightedMerchBizObjectives);

var _HighlightedMerchHeaderConfig = require('pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig');

var _HighlightedMerchHeaderConfig2 = _interopRequireDefault(_HighlightedMerchHeaderConfig);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BizObjHeaderLink = (0, _styledComponents2.default)(_UIButton2.default).withConfig({
  displayName: 'BizObjectives__BizObjHeaderLink'
})(['font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:', ' !important;', ';'], _colors.CALYPSO_DARK, _responsiveBreakpoints2.default.tablet(_templateObject, _colors.CALYPSO_DARK));

var BizObjHeaderNoLink = _styledComponents2.default.h6.withConfig({
  displayName: 'BizObjectives__BizObjHeaderNoLink'
})(['font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:', ' !important;', ';'], _colors.CALYPSO_DARK, _responsiveBreakpoints2.default.tablet(_templateObject, _colors.CALYPSO_DARK));

var BizObjWrapper = (0, _styledComponents2.default)(_UICardSection2.default).withConfig({
  displayName: 'BizObjectives__BizObjWrapper'
})(['padding-top:28px !important;', ';'], _responsiveBreakpoints2.default.phone(_templateObject2));

var BizLowerTierContainer = _styledComponents2.default.div.withConfig({
  displayName: 'BizObjectives__BizLowerTierContainer'
})(['font-size:14px;line-height:19px;padding-bottom:12px;']);

var BizCmsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'BizObjectives__BizCmsWrapper'
})(['min-height:300px;', ';', ';'], _responsiveBreakpoints2.default.tablet(_templateObject3), _responsiveBreakpoints2.default.tabletPortrait(_templateObject4));

var BizObjectives = function BizObjectives(_ref) {
  var merchandiseId = _ref.merchandiseId,
      inSingleColumnPriceDisplay = _ref.inSingleColumnPriceDisplay,
      hub = _ref.hub;

  var onBizObjHeaderClick = function onBizObjHeaderClick(bizObjKey) {
    return (0, _getUsageTracker2.default)().track('bizObjectiveClick', {
      bizObjectiveKey: bizObjKey,
      isLink: Boolean(_BizObjectivesMap2.default[bizObjKey].breakoutData)
    });
  };

  var renderFeature = function renderFeature(feature) {
    return _react2.default.createElement(
      'div',
      { key: feature },
      _react2.default.createElement(
        _UITooltip2.default,
        {
          placement: 'right',
          title: _react2.default.createElement(_FormattedMessage2.default, { message: (0, _getFeatureDescriptionKey2.default)(feature, hub) })
        },
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block m-y-1' },
          _react2.default.createElement(_UIIcon2.default, { className: 'm-right-3', color: _colors.OBSIDIAN, name: 'success' }),
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricing-pages.features.' + feature + '.name'
          })
        )
      )
    );
  };

  var renderBizObjectiveHeader = function renderBizObjectiveHeader(bizObjKey) {
    var bizObj = _BizObjectivesMap2.default[bizObjKey];
    var textNode = _react2.default.createElement(_FormattedMessage2.default, { message: 'pricing-pages.bizObjectives.' + bizObjKey });
    if (bizObj.breakoutData) {
      return _react2.default.createElement(
        BizObjHeaderLink,
        {
          use: 'link',
          onClick: (0, _partial2.default)(onBizObjHeaderClick, bizObjKey)
        },
        textNode
      );
    }

    return _react2.default.createElement(
      BizObjHeaderNoLink,
      { onClick: (0, _partial2.default)(onBizObjHeaderClick, bizObjKey) },
      textNode
    );
  };

  var renderBizObjective = function renderBizObjective(bizObjKey) {
    return _react2.default.createElement(
      'div',
      {
        key: bizObjKey,
        className: inSingleColumnPriceDisplay ? 'm-bottom-9' : null
      },
      renderBizObjectiveHeader(bizObjKey),
      _BizObjectivesMap2.default[bizObjKey].features.map(function (feature) {
        return renderFeature(feature);
      })
    );
  };

  if (inSingleColumnPriceDisplay) {
    var headerConfig = _HighlightedMerchHeaderConfig2.default[merchandiseId];
    var lowerTierPlus = headerConfig.lowerTierPlus;

    return _react2.default.createElement(
      BizObjWrapper,
      null,
      _react2.default.createElement(
        BizLowerTierContainer,
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: lowerTierPlus })
      ),
      _HighlightedMerchBizObjectives2.default[merchandiseId].map(function (bizKey) {
        return renderBizObjective(bizKey);
      })
    );
  }

  return _react2.default.createElement(
    BizCmsWrapper,
    null,
    _react2.default.createElement(
      _UICardGrid2.default,
      { columns: 2 },
      _HighlightedMerchBizObjectives2.default[merchandiseId].map(function (bizKey) {
        return renderBizObjective(bizKey);
      })
    )
  );
};

BizObjectives.propTypes = {
  merchandiseId: _react.PropTypes.number.isRequired,
  hub: _react.PropTypes.string.isRequired,
  inSingleColumnPriceDisplay: _react.PropTypes.bool
};
exports.default = BizObjectives;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/BizObjectives.js
// module id = 598
// module chunks = 3 4